import { DatesValues } from '@p81-common/ui';
import { periodFormat } from 'utils/common';
import { defaultFilters, NETWORK_WITH_FAILED_INSTANCES } from './config';

export const validateDatesValues = (fieldValue?: DatesValues) =>
  Array.isArray(fieldValue) ? { startDate: null, endDate: null } : fieldValue;

export const createReqBody = (filter = defaultFilters) => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      networkGwMinVersion: filter.networkGwMinVersion?.[0]
        ? filter.networkGwMinVersion
        : '*',
      networkVersion: filter.networkVersion?.[0] ? filter.networkVersion : '*',
      providerRegionName: filter.providerRegionName?.[0]
        ? filter.providerRegionName
        : '*',
      regionCountry: filter.regionCountry?.[0] ? filter.regionCountry : '*',
      partnerType: filter.partnerType?.[0] ? filter.partnerType : '*',
      featureAdoption: filter.featureAdoption?.[0]
        ? filter.featureAdoption
        : '*',
      'tunnels.tunnelType': filter['tunnels.tunnelType']?.[0]
        ? filter['tunnels.tunnelType']
        : '*',
      status: filter.status?.[0] ? filter.status : '*',
      firstPaymentDate: periodFormat(
        validateDatesValues(filter.firstPaymentDate)
      ),
      firstInvoiceAt: periodFormat(validateDatesValues(filter.firstInvoiceAt)),
      nextBillingDate: periodFormat(
        validateDatesValues(filter.nextBillingDate)
      ),
      companySize: filter.companySize?.[0] ? filter.companySize : '*',
      arr: {
        from: filter.arrChangedFrom ? +filter.arrChangedFrom : '*',
        to: filter.arrChangedTo ? +filter.arrChangedTo : '*'
      },
      plan: filter.plan?.[0] ? filter.plan : '*',
      billingCycle: filter.billingCycle?.[0] ? filter.billingCycle : '*',
      healthStatus: filter.healthStatus?.[0] ? filter.healthStatus : '*',
      industry: filter.industry?.[0] ? filter.industry : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer?.[0]
        ? filter.customerSuccessEngineer
        : '*',
      accountManager: filter.accountManager?.[0] ? filter.accountManager : '*',
      not_networkGwMinVersion: filter.not_networkGwMinVersion?.[0]
        ? filter.not_networkGwMinVersion
        : '*',
      not_providerRegionName: filter.not_providerRegionName?.[0]
        ? filter.not_providerRegionName
        : '*',
      statusFailed: filter.statusFailed
        ? filter.statusFailed === NETWORK_WITH_FAILED_INSTANCES
        : '*',
      networkId: filter.networkId?.[0] ? filter.networkId : '*',
      customerId: filter.customerId?.[0] ? filter.customerId : '*'
    },
    sort: {
      fieldName: 'companyName',
      direction: 1
    }
  };
};
